import { render, staticRenderFns } from "./batchExamineKp.vue?vue&type=template&id=69266422"
import script from "./batchExamineKp.vue?vue&type=script&lang=js"
export * from "./batchExamineKp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69266422')) {
      api.createRecord('69266422', component.options)
    } else {
      api.reload('69266422', component.options)
    }
    module.hot.accept("./batchExamineKp.vue?vue&type=template&id=69266422", function () {
      api.rerender('69266422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerContract/batchExamineKp.vue"
export default component.exports